import { getMessageFactoryV2 } from "../getCaxaWebSocketV2.js";
const getCurrentCupboardInfoV2 = getMessageFactoryV2({
  code: "GET_CURRENT_CUPBOARD_INFO"
});
export { getCurrentCupboardInfoV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/getCurrentCupboardInfoV2.js